<template>
  <div v-if="budget">
    <label class="form-control-label">
      <h4>Budget Name</h4>
    </label>
    <input
      ref="name"
      type="text"
      v-model="name"
      maxlength="255"
      @change="update"
      :disabled="disabled"
      class="form-control"
    />
    <nameValidation :$v="$v" />
  </div>
</template>

<script>
import { budgetService } from "@/api/client";
import nameValidation from "@/views/budget-control/instance/validation/name.vue";
import { FormEditValidateRule as validateRules } from "@/views/budget-control/instance/validation";

export default {
  props: ["budget"],

  components: {
    nameValidation,
  },

  validations: { name: validateRules.name },

  data() {
    return {
      id: null,
      name: null,
    };
  },

  computed: {
    disabled() {
      return !["draft", "scheduled", "paused"].includes(this.budget.status);
    },
  },

  mounted() {
    this.id = this.budget.id;
    this.name = this.budget.name;
  },

  methods: {
    async isFormValid() {
      if (this.$v.name.$invalid) {
        await this.$dialogs.alert("กรุณากรอก Budget Name ให้ถูกต้อง");
        this.$refs.name.focus();
        return false;
      }
      return true;
    },

    async update() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        await budgetService.updateBudget(this.budget.id, {
          name: this.name,
        });

        this.$notify(`Budget name updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Update Budget name error.`);
      }
    },
  },
};
</script>

<style></style>
